import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses, bonusesTotalValue } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-cream border-y border-silver-light" data-id="element-15" data-mp="22f3dzf1jrfnk">
      <div className="max-w-5xl mx-auto" data-id="element-16" data-mp="1ydrulr99nqnt">
        <div className="text-center mb-16" data-id="element-17" data-mp="1ybxagf5tk2ks">
          <p className="text-brand-dark font-bold tracking-widest uppercase mb-2" data-id="element-18" data-mp="1anxixd0oo855">
            Included at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-extrabold text-ink" data-id="element-19" data-mp="15qxcv23u35e1">
            🎁 The <span className="text-brand" data-id="element-20" data-mp="1jibzdiwy9opu">5 Strategic Bonuses</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-21" data-mp="1ep95tas6af9n">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-silver-light rounded-2xl p-8 relative flex flex-col" data-id="element-22" data-mp="qywx3xp3sei0" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-brand text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-23" data-mp="2jiei3ydihmxw">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-brand-soft border border-brand/25 rounded-full flex items-center justify-center text-brand mb-6" data-id="element-24" data-mp="1quaa367gwxs1">
                <Gift size={24} aria-hidden="true" data-id="element-25" data-mp="1vu51dav5npdm" />
              </div>
              <h3 className="text-xl font-display font-extrabold mb-2 pr-24 text-ink" data-id="element-26" data-mp="20ptt4s0xo1zd">
                {bonus.title}
              </h3>
              <div className="inline-flex flex-wrap items-center gap-2 bg-cream border border-silver-light px-3 py-1 rounded mb-4 self-start" data-id="element-27" data-mp="3c6k3mnce3fys">
                <span className="text-graphite-light text-sm" data-id="element-28" data-mp="3h4ln39dq9has">
                  Real value: <span className="line-through" data-id="element-29" data-mp="1h2vtgy0snv3r">${bonus.value}</span>
                </span>
                <span className="text-brand-dark font-bold" data-id="element-30" data-mp="1c4kigjyrjejy">→ FREE</span>
              </div>
              <p className="text-graphite text-sm mb-6 leading-relaxed flex-grow" data-id="element-31" data-mp="1q43isqlc1llp">{bonus.desc}</p>
              <p className="text-brand-dark text-sm italic font-medium mt-auto" data-id="element-32" data-mp="1m2i5j44vz5az">{bonus.benefit}</p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-brand/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-33" data-mp="ydp8f4cj2res">
          <p className="text-graphite mb-2" data-id="element-34" data-mp="12cekmtlty2wu">Total value of all 5 bonuses</p>
          <p className="text-2xl text-graphite-light line-through mb-4" data-id="element-35" data-mp="endhnlvrnjyy">{bonusesTotalValue}</p>
          <p className="text-lg text-ink mb-2" data-id="element-36" data-mp="amtkiib70gct">Your price today</p>
          <p className="text-5xl font-bold text-brand mb-4" data-id="element-37" data-mp="iv1ons79hhz">🎁 FREE</p>
          <p className="text-sm text-brand-dark" data-id="element-38" data-mp="5a4lh7r2hqly">Only included in this offer.</p>
        </motion.div>
        <CountdownTimer data-id="element-39" data-mp="3mqmiqp26fgjl" />
      </div>
    </section>;
}